import { render } from "./RolesAndPermissions.vue?vue&type=template&id=2b7237ea&scoped=true"
import script from "./RolesAndPermissions.vue?vue&type=script&lang=js"
export * from "./RolesAndPermissions.vue?vue&type=script&lang=js"

import "./RolesAndPermissions.vue?vue&type=style&index=0&id=2b7237ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7237ea"]])

export default __exports__